import React from "react";
import CertificateLetter from "./Letters/CertificateLetter";

const CertificateAragon = ({certificate}) => {

    return (
        <>
            <div className="card-body">
                <p><strong>Fecha</strong>: {certificate.emission_date}</p>
                <p><strong>Número de registro</strong>: {certificate.num_certificate}</p>
                <p><strong>Dirección</strong>: {certificate.address}</p>
                <p><strong>Municipio</strong>: {certificate.municipality}</p>
                <p><strong>Consumo</strong>: {certificate.consumption_energy}</p>
                <p><strong>Emisiones </strong>: {certificate.co_emission}</p>
                <p><strong>Classificación consumo </strong>: <CertificateLetter
                    letter={certificate.consumption_ranked}/></p>
                <p><strong>Classificación emisiones </strong>:<CertificateLetter
                    letter={certificate.emission_ranked}/></p>
            </div>
        </>

    );
}


export default CertificateAragon;